import {
	SET_VIDEOS,
	SET_VIDEOS_PROM,
	SET_VIDEOS_TESTI,
	SET_HOME_VIDEO
} from '../actions/Types';

const INITIAL_STATE = {
	videos: [],
	videosProm: [],
	videosTesti: [],
	homeVideo: {}
}

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case SET_VIDEOS:
			return { ...state, videos: action.payload };
		case SET_VIDEOS_PROM:
			return { ...state, videosProm: action.payload };
		case SET_VIDEOS_TESTI:
			return { ...state, videosTesti: action.payload };
		case SET_HOME_VIDEO:
			return { ...state, homeVideo: action.payload}
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/VideosReducer.js